// @noflow
import React from 'react'

import {
  Direction,
  ICON_COLOURS,
  IconColours
} from '@/components/elements/atoms/Icon/Icon'

import STYLES from './curvedarrow.module.sass'

type Props = {
  size: number
  accentColour: IconColours
  width?: number | string
  direction?: Direction
}

const CurvedArrow = ({
  size,
  accentColour,
  width,
  direction = 'right'
}: Props): JSX.Element => {
  return (
    <svg
      fill="none"
      height={size}
      viewBox="0 0 53 81"
      width={width || '100%'}
      className={`${direction ? STYLES[direction] : ''}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.416 79.155c-.506.55-1.087.688-1.627.204-1.133-1.015-2.595-1.55-3.672-2.667-.76-.778-1.395-1.64-2.106-2.437-.52-.587-1.204-1.05-1.323-1.956-.057-.443-.398-.845-.587-1.296-.74-1.72-1.484-3.435-2.198-5.165-.43-1.037-.806-2.099-1.207-3.147-.03-.111-.028-.254-.09-.339-.792-1-.768-2.268-1.124-3.408-.161-.505-.344-.998-.476-1.518a11.55 11.55 0 0 1-.312-1.57c-.242-2.085-.568-4.181-.254-6.278.291-1.963.714-3.911 1.08-5.866.381-2.02 1.272-3.876 1.892-5.818.336-1.075.761-2.12 1.27-3.123.636-1.235 1.41-2.398 2.13-3.59.076-.126.221-.22.27-.352.427-1.117 1.304-1.912 2.016-2.847.532-.724 1.128-1.414 1.681-2.13.254-.376.48-.77.676-1.18.378-.311.778-.607 1.13-.945.68-.654 1.319-1.345 2.01-1.992.292-.267.63-.444.927-.691.736-.6 1.461-1.216 2.191-1.826.82-.685 1.606-1.411 2.466-2.038 1.045-.763 2.158-1.439 3.232-2.163.414-.282.804-.604 1.21-.902 1.126-.832 2.487-1.19 3.696-1.855.981-.542 2.048-.912 2.857-1.757a2.4 2.4 0 0 1 1.049-.466c.823-.22 1.655-.426 2.482-.647a13.97 13.97 0 0 0 2.603-.901c.86-.427 1.86-.586 2.806-.825 1.39-.372 2.795-.672 4.19-1.013a.982.982 0 0 0 .25-.173c-.934-.545-1.959-.601-2.919-.863-.595-.16-1.186-.358-1.77-.543a1.787 1.787 0 0 0-.405-.157c-1.418-.088-2.673-.77-4.017-1.125-1.173-.307-2.334-.657-3.506-.975-.282-.077-.58-.092-.867-.131a1.449 1.449 0 0 1-.584-.16.796.796 0 0 1-.362-.535.664.664 0 0 1 .428-.478 5.685 5.685 0 0 1 1.65.045c.541.12 1.033.45 1.568.615.313.074.636.092.955.053a3.33 3.33 0 0 1 1.997.58c.162.131.357.216.564.245 1.267-.042 2.294.697 3.447 1.016 1.238.305 2.492.536 3.757.694.33.053.627.02.842.363.108.17.382.26.582.342.343.166.69.323 1.041.469.152.083.321.129.494.133 1.05-.15 1.679.64 2.47 1.082.43.248.335.75.176 1.133-.591 1.427-1.112 2.885-2.137 4.093a2.951 2.951 0 0 0-.905 1.812c-.008.366-.249.43-.553.432a.916.916 0 0 1-.903-1.157c.041-.205.12-.4.235-.575.46-.646.935-1.282 1.422-1.907a1.754 1.754 0 0 0 .49-1.276c-.027-.44.228-.896.364-1.354.132-.036.284-.076.44-.093l.04-.163c-.193-.094-.383-.26-.58-.266-.59-.027-1.18-.012-1.768.045-.964.106-1.928.222-2.877.408-.843.164-1.666.413-2.495.643-1.406.377-2.816.754-4.205 1.2-1.47.462-2.936.957-4.38 1.51-.7.323-1.384.683-2.046 1.08-1.322.68-2.655 1.332-3.963 2.035a18.66 18.66 0 0 0-2.039 1.273c-1.218.878-2.424 1.8-3.632 2.713-1.038.79-2.13 1.54-3.092 2.398-1.558 1.373-3.12 2.758-4.54 4.264a30.809 30.809 0 0 0-3.805 4.78c-.613.978-1.33 1.897-1.926 2.885a24.845 24.845 0 0 0-1.637 3.058c-.7 1.64-1.358 3.27-1.91 4.965a66.905 66.905 0 0 0-1.413 5.07 25.266 25.266 0 0 0-.653 4.763c-.16 3.363.616 6.555 1.619 9.702.358 1.12.762 2.222 1.074 3.345a24.44 24.44 0 0 0 1.162 2.98 116.267 116.267 0 0 0 1.7 3.824c.304.608.638 1.2 1.002 1.773.652 1.079 1.35 2.123 2.389 2.895.268.2.376.604.637.82.566.47 1.176.892 1.783 1.31.81.532 1.596 1.037 2.423 1.59Z"
        fill={ICON_COLOURS[accentColour]}
        stroke={ICON_COLOURS[accentColour]}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </svg>
  )
}

export default CurvedArrow
